import { render, staticRenderFns } from "./SelectCourses.vue?vue&type=template&id=48bdae94&scoped=true"
import script from "./SelectCourses.vue?vue&type=script&lang=js"
export * from "./SelectCourses.vue?vue&type=script&lang=js"
import style0 from "./SelectCourses.vue?vue&type=style&index=0&id=48bdae94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bdae94",
  null
  
)

export default component.exports